<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Balance Sheet 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row >
            <div class="report-wraper">
                <table  style="width: 100%;">
                    <thead>
                        <tr>
                        <th >AKTIVA</th>
                        <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMMYYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Month to date</th>
                        <th v-if="filter.tglbulanlalu" style="text-align:right" width="140px">{{filter.tglbulanlalu | moment("MMM YYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Previous Month</th>
                        <th width="45px"></th>
                        <th >PASIVA</th>
                        <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMMYYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Month to date</th>
                        <th v-if="filter.tglbulanlalu" style="text-align:right" width="140px">{{filter.tglbulanlalu | moment("MMM YYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Previous Month</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rptLines" :key="row.idrowunik">
                        <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                        <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.sdakhir | numFormat}}</td>
                        <td v-else ></td>
                        <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.sdawal | numFormat}}</td>
                        <td v-else ></td>
                        <td></td>
                        <td :class="row.kelas2"><span v-html="row.uraianhtm2"></span></td>
                        <td :class="row.kelas2" v-if="row.kode2 || row.rumus2"  style="text-align:right">{{row.sdakhir2 | numFormat}}</td>
                        <td v-else ></td>
                        <td :class="row.kelas2" v-if="row.kode2 || row.rumus2"  style="text-align:right">{{row.sdawal2 | numFormat}}</td>
                        <td v-else ></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import bs from "../../apis/consolidabs";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptLines= await bs.layout({layout : newval});
      }
  },
created: async function (){
     this.layouts = await bs.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktifconsol, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
    // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').subtract(1, 'day');
    this.filter.tglbulanini= tgl2;

  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
        // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').subtract(1, 'day');
        this.filter.tglbulanini= tgl2;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.rptLines= await bs.rptbs(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.showReport=true;
                this.reportUrl= await bs.rptbsprint(model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await bs.rptbsexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillSdAkhir: function(data){
        if (data.kode) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY')}-01-01/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillSdAwal: function(data){
        if (data.kode) {
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${this.filter.tgltahunlalu.format('YYYY')}-01-01/${this.filter.tgltahunlalu.format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillSdAkhir2: function(data){
        if (data.kode2) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            let routeData = router.resolve({path: `general-ledger/${data.kode2}/${tgl2.format('YYYY')}-01-01/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillSdAwa2l: function(data){
        if (data.kode2) {
            let routeData = router.resolve({path: `general-ledger/${data.kode2}/${this.filter.tgltahunlalu.format('YYYY')}-01-01/${this.filter.tgltahunlalu.format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    close(){
      router.push("/accounting/home");
    }
  }
};
</script>
